import { render } from "./BaseCard.vue?vue&type=template&id=e547b7e2&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=e547b7e2&lang=scss&scoped=true"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e547b7e2"]])

export default __exports__